import { NgModule } from '@angular/core';
import { ItemSearchMultiSelectFilterComponent } from './item-search-multi-select-filter/item-search-multi-select-filter.component';
import { ItemSearchSingleSelectFilterComponent } from './item-search-single-select-filter/item-search-single-select-filter.component';
import { MatInputModule } from '@angular/material/input';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { GalaxyInfiniteScrollTriggerModule } from '@vendasta/galaxy/infinite-scroll-trigger';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import { InventoryUiI18nModule } from '../i18n/inventory-ui-i18n.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DisplayLabelPipe } from './display-label.pipe';
import { ItemSearchSelectFilterService } from './item-search-select-filter.service';

@NgModule({
  declarations: [ItemSearchMultiSelectFilterComponent, ItemSearchSingleSelectFilterComponent, DisplayLabelPipe],
  imports: [
    CommonModule,
    MatInputModule,
    MatIconModule,
    MatChipsModule,
    GalaxyInfiniteScrollTriggerModule,
    GalaxyWrapModule,
    GalaxyFormFieldModule,
    InventoryUiI18nModule,
    TranslateModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatFormFieldModule,
  ],
  providers: [ItemSearchSelectFilterService],
  exports: [ItemSearchMultiSelectFilterComponent, ItemSearchSingleSelectFilterComponent],
})
export class ItemSearchSelectFilterModule {}
